export class ManageTRSModel {
    userid: number;
    title: string;
    description: string = '';
}